export const openAiSupportedLanguages = [
  "English (US)", // Should be first
  "English (UK)",
  "Spanish",
  "French",
  "German",
  "Portuguese",
  "Italian",
  "Dutch",
  "Russian",
  "Chinese (Simplified)",
  "Chinese (Traditional)",
  "Japanese",
  "Korean",
  "Arabic",
  "Turkish",
  "Polish",
  "Swedish",
  "Norwegian",
  "Danish",
  "Finnish",
  "Czech",
  "Hungarian",
  "Romanian",
  "Greek",
  "Hebrew",
  "Hindi",
  "Bengali",
  "Urdu",
  "Thai",
  "Vietnamese",
  "Indonesian",
  "Malay",
  "Ukrainian",
  "Slovak",
  "Bulgarian",
  "Croatian",
  "Serbian",
  "Lithuanian",
  "Latvian",
  "Estonian",
  "Filipino (Tagalog)",
  "Persian (Farsi)",
  "Swahili",
] as const;
